import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const WarningIcon = (props: SvgIconProps) => (
  <WarningAmberOutlinedIcon {...props} fontSize="small" />
);

export default WarningIcon;
